// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3lB63","footer":"Form_footer__ALrLT"};